<div class="website-texting-banner">
  <button class="dismiss-btn" (click)="dismiss()">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <div class="phone-mockup">
    <img src="assets/images/website-texting-phone.png" alt="" />
  </div>

  <div class="banner-bottom">
    <div class="label-row">
      <img class="sms-icon" src="assets/images/icon-sms-active.svg" alt="" />
      <span class="label-text">{{ 'WEBSITE_TEXTING_BANNER.LABEL' | translate }}</span>
    </div>
    <div class="title-row">
      <p class="title-text">{{ 'WEBSITE_TEXTING_BANNER.TITLE' | translate }}</p>
      <button class="cta-btn" (click)="navigate()">
        <ng-icon name="heroArrowRightMini"></ng-icon>
      </button>
    </div>
  </div>
</div>
